import React from "react";
import { useNavigate } from "react-router-dom";
import icons from "../icons";
import { Link } from 'react-router-dom';
import  {charactersOnly, encodePassword, isValidWeakPassword, numberOnly, passwordLength,isValidStrongPassword, checkPassword}  from "../services/Util.js";
import { forgotPasswordVerify, getUserInfo } from "../services/authApiRoutes/APImethods";
import  { useEffect, useRef, useState } from "react";
import $ from "jquery"
import images from "../images";
import { resetPasswordSchema } from "../ValidationSchema";
import { ConditionalBlock } from "../ConditionalBlock";

export default function UpdatePassword() {
  const backRef = useRef(null)
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const id = params.get('id'); 
  const token = params.get('token'); 
  const [userInfo,setUserInfo]=useState({})
  const [strongPassword,setStrongPassword]=useState(false);
  const [verifyPassword,setVerifyPassword]=useState({});
  const [weakPasswordStatus,setWeakPasswordStatus]=useState(false)
  const [status,setStatus]=useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [errors,setErrors] = useState({});

  const [invalidLink,setInvalidLink] = useState(false)
  const navigateToLogin = () => {
    setStatus(false)
    navigate("/");
  };
   
  useEffect( ()=>{
    getUserData();
    backRef.current.focus();
  },[])

  const passwordCheck=(event)=>{
    let password=event?.target?.value
    setWeakPasswordStatus(isValidWeakPassword(password))
    setStrongPassword(isValidStrongPassword(password))
    if(isValidStrongPassword(password)){
      setWeakPasswordStatus(false)
    }
    setVerifyPassword({...verifyPassword,'password':password})
  }

  useEffect(()=>{
    if (isFirstRender) {
      setIsFirstRender(false);
    } else {
      if(errors && Object.keys(errors).length>0){
        Object.keys(errors).map((key,index)=>{
          $('#'+key).attr('aria-describedby', "passLength-"+index);
        })
      }
    }
  }, [errors]);

  const isVerifyPassword=(event)=>{
    let confirmPassword=event?.target?.value
    setVerifyPassword({...verifyPassword,'confirmPassword':confirmPassword})
  }
 
  const getUserData=async()=>{
    const result= await getUserInfo({id:id,token:token});
    if(result && result.data?.code===200){
      setInvalidLink(false)
      setUserInfo(result?.data?.data)
    }
    else{
      setInvalidLink(true)
    }
  }

  const onFormSubmit = (event) =>{
    event.preventDefault();
    let data=verifyPassword;
    try {
      resetPasswordSchema.validateSync(data,{abortEarly:false})
      const apiData={userId:userInfo.userId,password:data.password,confirmPassword:data.confirmPassword,oldPassword:userInfo.oldPassword,random:userInfo?.random}
      forgotPasswordVerify(apiData).then(data=>{
        if(data.data.code===200){
          setStatus(true)
        }
      })
    } catch (errors) {
      let dataErrors = {};
      errors.inner.forEach((element) => {
        dataErrors[element.path]=element.message;
      });
      setErrors(dataErrors);
    }
  } 


  return (
    <div className="wrapper">
      <div className="sign-page">
        <div className="content">
          <div className="back" >
            <button ref={backRef} type="button" onClick={navigateToLogin}>
              <i aria-hidden="true"></i>Back
            </button>
          </div>
          <div className="small-container">
            <div className="logo-block">
              <Link to="/">
                <img src={icons.OPAL_LOGO} alt="Logo" />
              </Link>
            </div>
            <ConditionalBlock condition={!invalidLink}>
              <ConditionalBlock condition={!status}>
                <div className="inner-content-wrap update-password ">
                  <h1> Complete Your Profile</h1>
                  {
                    Object.keys(errors).map((key,index)=>(
                      <p className="error" id={"passLength-"+index} role="alert">
                        {errors[key]}<br/>
                      </p>))
                  }
                  <form onSubmit={onFormSubmit}>
                    <div className="wrap-form">
                      <div className="input-group">
                        <input id="password" type="Password" className="form-control" placeholder="New password"
                          aria-required="true" aria-describedby="password-instructions"  name="password" autoComplete="off"
                          maxLength="64" onChange={passwordCheck}
                        />
                        <div id={strongPassword ? "strenghtMsg" : undefined} className={strongPassword?"pass-strength-success":"hide"}
                          aria-hidden={strongPassword?"false":"true"}>
                          Strong
                        </div>
                        <div id={weakPasswordStatus ? "strenghtMsg" : undefined} className={weakPasswordStatus?"pass-strength-success":"hide"}
                          aria-hidden={weakPasswordStatus?"false":"true"}>
                          weak
                        </div>
                        <div id="password-instructions" className="instruction">
                          Atleast 8 characters, 1 number, and 1 letter
                        </div>
                      </div>
                      <div className="input-group">
                        <input id="confirmPassword" type="Password" className="form-control"
                          placeholder="Confirm new password" aria-required="true"
                          name="confirmPassword" maxLength="64" autoComplete="off" onChange={isVerifyPassword}
                        />
                      </div>
                      <div className="form-button">
                        <button  type="submit" className="btn">
                          Update Password
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ConditionalBlock>
              <ConditionalBlock condition={status}>
                <div className={"inner-content-wrap password-reset"}>
                  <h1>Successful Password Reset!</h1>
                  <p>
                    You can now use your new password to login into your account! 👍🏻
                  </p>
                  <div className="image-block">
                  <img src={images.RESET_PASSWORD_SUCCESS} alt="Successful Password Reset Icon" />
                  </div>
                  <div className="wrap-form">
                    <div className="form-button">
                      <button  onClick={navigateToLogin} type="button" className="btn">
                        Return to login
                      </button>
                    </div>
                  </div>
                </div>
              </ConditionalBlock>
            </ConditionalBlock>
            <ConditionalBlock condition={invalidLink}>
              <div >
                <h6>Password reset link is only good for one time use and is no longer valid.To reset your password again,
                <Link to="/forgot-password">click here</Link>
                </h6>
              </div>
            </ConditionalBlock>

          </div>
        </div>
      </div>
    </div>
  );
}
